(function () {
    "use strict";

    angular.module("app").filter("utcToLocalDate", Filter);

    function Filter() {
        return (input) => {
            if (angular.isObject(input)) {
                const date = new Date(input);
                const _utc = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
                return _utc;
            }
        };
    }
})();
